<template>
  <CustomPage title="物流信息">
    <div slot="content" class="locus-container">
      <div class="head van-hairline--bottom">
        <div class="cell">
          <div class="label">发货日期:</div>
          <div class="value">
            {{ dayjs(deliveryTime).format('YYYY-MM-DD') }}
          </div>
        </div>
        <div class="cell">
          <div class="label">物流公司:</div>
          <div class="value">{{ logisticsName }}</div>
        </div>
        <div class="cell">
          <div class="label">物流单号:</div>
          <div class="value">{{ com }}</div>
        </div>
      </div>
      <div class="steps-wrapper">
        <Steps direction="vertical" class="steps">
          <Step class="step" v-for="(item, index) in list" :key="index">
            <h3>{{ item.context }}</h3>
            <p>{{ item.time }}</p>
          </Step>
        </Steps>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import { Step, Steps } from 'vant'
import { getLocusList } from '@/api/order/inSale'
export default {
  components: { CustomPage, Steps, Step },
  data() {
    return {
      list: [],
      deliveryTime: this.$route.query.deliveryTime,
      logisticsCompany: this.$route.query.logisticsCompany,
      code: this.$route.query.code,
      com: null,
      logisticsName: null,
    }
  },
  created() {
    console.log(this.$route.query.id)
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('app/showLoading')
      getLocusList(this.$route.query.id)
        .then((res) => {
          this.list = res.data.data || []
          this.com = res.data.com
          this.logisticsName = res.data.logisticsName
          this.deliveryTime = res.data.deliveryTime
          this.$store.dispatch('app/hideLoading')
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
  },
}
</script>

<style lang="less" scoped>
.locus-container {
  padding: 22px 24px;
  .head {
    padding-bottom: 24px;
    .cell {
      display: flex;
      padding: 16px 0;
      font-size: 28px;
      line-height: 1em;
      .value {
        margin-left: 14px;
      }
    }
  }
  .steps-wrapper {
    padding-top: 30px;
    h2 {
      font-size: 32px;
      line-height: 1em;
      padding-bottom: 10px;
      font-weight: bold;
    }
    h3 {
      font-size: 28px;
      line-height: 40px;
    }
    p {
      font-size: 28px;
      line-height: 40px;
      padding-top: 4px;
    }
    .step {
      &::after {
        display: none;
      }
    }
  }
}
</style>
